import React, { useEffect, useState } from 'react';

import SeoHelmet from "../components/SeoHelmet";

import ContactModal from "../components/ContactModal";
import ContactForm from "../components/ContactForm";
import CustomerSay from "../components/CustomerSay";

import Pro2 from '../assets/img/arrow_right.svg';
import Pro4 from '../assets/img/arrow_right.svg';

import arrowleft from '../assets/img/arrow-left.png';
import arrowright from '../assets/img/arrow-right.png';

import Pro6 from '../assets/img/arrow_right.svg';



import Slide1 from '../assets/img/ambience.jpg';
import Icon1 from '../assets/img/icon1.png';
import Icon2 from '../assets/img/Shape.svg';
import Launch from '../assets/img/launch_20.svg';
import Get1 from '../assets/img/launch_bg.jpg';
import Get2 from '../assets/img/get_in_touch_bg.jpg';
import Get3 from '../assets/img/letsrevi.png';


import Sol1 from '../assets/img/sol_1.svg';
import Sol2 from '../assets/img/sol_2.svg';
import Sol3 from '../assets/img/sol_3.svg';
import Sol4 from '../assets/img/sol_4.svg';
import Sol5 from '../assets/img/sol_5.svg';
import Sol6 from '../assets/img/sol_6.jpg';
import Sol7 from '../assets/img/sol_7.jpg';
import Sol8 from '../assets/img/sol_8.jpg';
import Sol9 from '../assets/img/sol_9.svg';
import Sol10 from '../assets/img/sol_10.svg';
import Sol11 from '../assets/img/sol_11.jpg';
import Sol12 from '../assets/img/sol_12.jpg';
import Sol13 from '../assets/img/sol_13.jpg';
import Sol14 from '../assets/img/sol_14.jpg';
import Sol15 from '../assets/img/sol_15.jpg';
import Sol16 from '../assets/img/sol_16.svg';
import Sol17 from '../assets/img/sol_17.jpg';
import Sol18 from '../assets/img/sol_18.jpg';
import Sol19 from '../assets/img/sol_19.svg';
import Sol20 from '../assets/img/sol_20.jpg';
import Sol21 from '../assets/img/sol_21.svg';



import Col1 from '../assets/img/harmony_pro_1.svg';
import Col2 from '../assets/img/harmony_pro_2.svg';
import Col3 from '../assets/img/harmony_pro_3.jpg';
import Col4 from '../assets/img/harmony_pro_4.svg';


import Furn1 from '../assets/img/indus-1.jpg';
import Furn2 from '../assets/img/indus-2.jpg';
import Furn3 from '../assets/img/indus-3.jpg';
import Furn4 from '../assets/img/indus-4.jpg';
import Furn5 from '../assets/img/indus-5.jpg';



import Amb1 from '../assets/img/ambience_img_1.jpg';
import Amb2 from '../assets/img/ambience_img_2.jpg';
import Amb3 from '../assets/img/ambience_img_3.jpg';
import Amb4 from '../assets/img/ambience_img_4.jpg';
import Amb5 from '../assets/img/ambience_img_5.svg';



import Craf1 from '../assets/img/craf_1.svg';
import Craf2 from '../assets/img/craf_2.svg';
import Craf3 from '../assets/img/craf_3.svg';
import Craf4 from '../assets/img/craf_4.jpg';
import Craf5 from '../assets/img/craf_5.jpg';



import User1 from '../assets/img/user_1.jpg';
import User2 from '../assets/img/user_2.jpg';
import User3 from '../assets/img/user_3.jpg';

const tabs = [
  {
    title: "Bedding and Linen",
    subtitle: "Plush, durable linens for ultimate guest comfort",
  },
  {
    title: "Bath Essentials",
    subtitle: "Premium towels, robes, and spa-ready essentials",
  },
  {
    title: "Curtains and Upholstery",
    subtitle: "Custom drapes and fabrics to elevate interiors",
  },
  {
    title: "Branded Customization",
    subtitle: "Personalized designs reflecting your property’s identity",
  },
  {
    title: "Tailored Decor",
    subtitle: "Finishing touches crafted to complete the ambiance",
  },
];

const Harmonyinternal = () => {
  const [activeTab, setActiveTab] = useState(0);
useEffect(() => {

    if (window.Swiper) {

      const custswiper = new window.Swiper(".customerslide", {
           loop: true,
           slidesPerView: 1,
           navigation: {
             nextEl: ".testi-button-next",
             prevEl: ".testi-button-prev",
           },
           pagination: {
             el: ".swiper-paginationnn",
             clickable: true,
           },
           breakpoints: {
             768: {
               slidesPerView: 3,
               spaceBetween: 30,
               slidesPerGroup: 3,
   
             },
             // You can add more breakpoints if needed
           },
   
         });

         const swiper = new window.Swiper(".instpostslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-nextn",
          prevEl: ".testi-button-prevn",
        },
        pagination: {
          el: ".swiper-paginationn",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,

          },
          // You can add more breakpoints if needed
        },

      });
    }




  }, []);


  return (
    <>
      <SeoHelmet />
 <ContactModal />
      <section>
        <div className="swiper animeslide">
          <div className="swiper-wrapper">

            <div className="swiper-slide animeslide-slide slide1 " style={{ backgroundImage: `url(${Slide1})` }}>
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h2>Reinventing Spaces, <br></br>Redefining Luxury</h2>
                        <p>Customized end-to-end solutions blending<br></br> elegance, brand essence, and invisible luxury</p>
                      </div>
                      <div data-animate="bottom" className="animeslide-desc">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Let’s Get Started</span><img src={Icon1} alt="" /></a>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ambience_and_harmony_section" style={{ backgroundImage: `url(${Get1})` }}>
        <div className="container">
          <div className="row about_the_studio">
            <div className="col-sm-6">
              <div className="ambience_content">
                <div className="brands_content ambience_har" >
                  <p><b>Ambience & Harmony,</b> a dedicated vertical of the Saraogi Clothing Company, brings over five decades of textile expertise to the hospitality sector. We specialize in reinventing spaces through thoughtfully designed bed linens, bath essentials, cushions, spa wear, and more—each crafted to complement your property’s unique identity. Our process goes beyond supplying products: we assess your space, understand your brand ethos, and create bespoke solutions that combine luxury, functionality, and the character of your property — <b>overseeing everything from design to delivery and on-site installation</b></p>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="ambience_imgs">
                <img src={Launch} alt="" className='studio' />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container my-16">
        {/* Tab Headers */}
         <div className="for_every_space brands_content " >
            <h2>Complete, Customizable Furnishing <br></br> Solution for Every Space</h2>
          </div>
         <div className="w-full overflow-x-auto py-4">
      <div className="flex gap-2 min-w-max">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={` rounded-2xl ${
              activeTab === index
                ? "text-white"
                : ""
            }`}
          >
            <div className="font-semibold">{tab.title}</div>
            <div className="text-sm opacity-80">{tab.subtitle}</div>
          </button>
        ))}
      </div>
      {/* Content */}
     
    </div>
  
      

        {/* Tab Content */}
        <div className="py-10">
          {activeTab === 0 && (
            <section className="brands_section industries_we_dress proudct_tab">
              <div className="industries_we_dress_with_purpose proudct_tab_content harmony_tab ">
                <div className="container">
                  
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol1})` }}>
                        <h3>Bedsheets</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol2})` }}>
                        <h3>Comforters</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol3})` }}>
                        <h3>Pillows</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol4})` }}>
                        <h3>Duvets</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol5})` }}>
                        <h3>Mattress Toppers</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {activeTab === 1 && (
            <section className="brands_section industries_we_dress proudct_tab">
              <div className="industries_we_dress_with_purpose proudct_tab_content harmony_tab">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol6})` }}>
                        <h3>Towels</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol7})` }}>
                        <h3>Bath Mats</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol8})` }}>
                        <h3>Robes</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol9})` }}>
                        <h3>Face Towels</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol10})` }}>
                        <h3>Hotel Slippers</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}


          {activeTab === 2 && (
            <section className="brands_section industries_we_dress proudct_tab">
              <div className="industries_we_dress_with_purpose proudct_tab_content harmony_tab">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol11})` }}>
                        <h3>Custom Curtains</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol12})` }}>
                        <h3>Sheers</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol13})` }}>
                        <h3>Sofa Fabrics</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol14})` }}>
                        <h3>Blinds</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}

          {activeTab === 3 && (
            <section className="brands_section industries_we_dress proudct_tab">
              <div className="industries_we_dress_with_purpose proudct_tab_content harmony_tab">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol15})` }}>
                        <h3>Throw Pillows</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol16})` }}>
                        <h3>Table Runners</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol17})` }}>
                        <h3>Cushion Covers</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol18})` }}>
                        <h3>Sofa</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol19})` }}>
                        <h3>Upholstered Chair</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {activeTab === 4 && (
            <section className="brands_section industries_we_dress proudct_tab">
              <div className="industries_we_dress_with_purpose proudct_tab_content harmony_tab">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol20})` }}>
                        <h3>Outdoor upholstery</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Sol21})` }}>
                        <h3>waterproof by the pool furnishings</h3>
                        {/* <p>Lorem Ipsum is dummy</p> */}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </section>
          )}
        </div>
      </section>
      <section className="our_process_section design_process">
        <div className="container">
          <div className="row">
            <div className="brands_content internal_harmony_process " >
              <h2>Our Process From Concept to Comfort</h2>
              <p>A collaborative, insight-driven process to transform spaces with textiles that embody your<br></br> brand’s story and elevate guest experience.</p>
            </div>
            <div className="process_content_img" >
              <div className="process_content_img_1 harmony_img" >
                <img src={Col1} alt="" className='logom harseimg' />
                <h3>1. Space & Brand Assessment</h3>
                <p>Analyze property layout, brand ethos, and guest expectations</p>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro2} alt="" className='logomm' />

              </div>
              <div className="process_content_img_1" >
                <img src={Col2} alt="" className='logom harseimg' />
                <h3>2. Concept/Design Development</h3>
                <p>Create tailored design concepts aligning functionality with brand identity</p>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro4} alt="" className='logomm' />

              </div>
              <div className="process_content_img_1" >
                <img src={Col3} alt="" className='logom harseimg' />
                <h3>3. Prototyping & Refinement</h3>
                <p>Develop samples, refine details, and ensure approval through feedback</p>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro6} alt="" className='logomm' />
                <h3></h3>
              </div>
              <div className="process_content_img_1" >
                <img src={Col4} alt="" className='logom harseimg' />
                <h3>4. Delivery & Installation</h3>
                <p>Oversee production, coordinate logistics, & ensure flawless setup</p>
              </div>

            </div>
            <div data-animate="bottom" className="animeslide-desc harmo">
              <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Let’s Get Started</span><img src={Icon1} alt="" /></a>
            </div>
          </div>
        </div>
      </section>
      <section className="brands_section industries_we_dress proudcts_tab serve">
        <div className="industries_we_dress_with_purpose proudct_tab_content">
          <div className="container">
             <div className="brands_content global_title industry_title " >
            <h2>Industries We Serve</h2>
          </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="ind_1 brmbr">
                  <img src={Furn1} alt="" className='logom' />
                  {/* <h3>Hotels & Resorts</h3> */}

                </div>
              </div>
              <div className="col-sm-4">
                <div className="ind_1 brmbr">
                  <img src={Furn2} alt="" className='logom' />
                  {/* <h3>Hospitals & Wellness Centers</h3> */}

                </div>
              </div>
              <div className="col-sm-4">
                <div className="ind_1 brmbr">
                  <img src={Furn3} alt="" className='logom' />
                  {/* <h3>Corporate Guesthouses</h3> */}

                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-2"></div>
              <div className="col-sm-4">
                <div className="ind_1 brmbr" >
                  <img src={Furn4} alt="" className='logom' />
                  {/* <h3>Educational Institutions</h3> */}

                </div>
              </div>
              <div className="col-sm-4">
                <div className="ind_1 brmbr">
                  <img src={Furn5} alt="" className='logom' />
                  {/* <h3>Luxury Villas & Private<br></br> Residences</h3> */}

                </div>
              </div>
              <div className="col-sm-2"></div>

            </div>
          </div>
        </div>
      </section>
      <section className="ambience_and_harmony_section">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="ambience_content">
                <div className="brands_content ambience_contents why_ambience" >
                  <h2>Why Ambience & Harmony?</h2>
                  <p>We don’t just furnish spaces — we reimagine them. With decades of expertise, we craft tailored textile solutions that merge comfort, elegance, and your brand’s unique identity.</p>
                  <h4>Our Promise</h4>
                  <ul className='harmony_ul'>
                    <li>Backed by 50+ Years of Textile Expertise</li>
                    <li>End-to-End Customised Solutions</li>
                    <li>Designs Aligned with Brand Ethos</li>
                    <li>Premium Materials, Lasting Quality</li>
                    <li>On-Time, Hassle-Free Delivery</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="ambience_imgs">
                <div className="row">
                  <div className="col-sm-5">
                    <img src={Amb1} alt="" className='logom' />
                    <img src={Amb3} alt="" className='logom' />
                  </div>
                  <div className="col-sm-7">
                    <img src={Amb2} alt="" className='logom' />
                    <img src={Amb4} alt="" className='logom' />
                    <img src={Amb5} alt="" className='ambience_img' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="get_in_touch_section letsreinvent" style={{ backgroundImage: `url(${Get2})` }}>
        <div className="container">
          <div className="row get_in_touch">
            <div className="col-sm-5 get_in_touch_left">
              <div className="get_in_touch_lefts">
                <div className="brands_content get_content lets" >
                  <h2>Let’s Reinvent Your Space</h2>
                 
                </div>
                <img src={Get3} alt="" className='get_in_touch getletrevi' />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="get_in_touch_right">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="crafted_section crafspacesng">
        <div className="container">
           <div className="brands_content global_title" >
            <h2>Crafted Spaces</h2>
          </div>
          <div class="swiper craftedSwiper instpostslide">
            <div class="swiper-wrapper crafted">
              <div class="swiper-slide"><img src={Craf1} alt="" className='logom' /></div>
              <div class="swiper-slide"><img src={Craf2} alt="" className='logom' /></div>
              <div class="swiper-slide"><img src={Craf3} alt="" className='logom' /></div>
              <div class="swiper-slide"><img src={Craf4} alt="" className='logom' /></div>
              <div class="swiper-slide"><img src={Craf1} alt="" className='logom' /></div>

            </div>
            <div className='arrowbtn'>
              <div class="testi-button-nextn"><img src={arrowleft} ></img> </div>
              <div class="testi-button-prevn"><img src={arrowright} ></img></div>
            </div>
           
          </div>
        </div>
      </section>
       <CustomerSay />
    </>
  );
};

export default Harmonyinternal;
